import React from "react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { PasswordForm } from "../../../Components/molecules/AuthForms/PasswordForm";
import { AuthWrap } from "../../../Components/templates/AuthWrap/AuthWrap";
import { CallCenterAgent, SuperAdmin } from "../../../Constants/AppContants";
import { useAuth } from "../../../Store/AuthContext";

export const Password = () => {
  const navigate = useNavigate();
  window.onpopstate = function (event) {
    event.preventDefault();
    navigate("/signin/enter-username");
  };
  const { t } = useTranslation(["glossary"]);
  const { state, dispatch } = useAuth();

  return (
    <AuthWrap
      pageTitle={t("glossary:auth.password.title")}
      pageSubheading={t("glossary:auth.password.subheading")}
      // formWidth={"354px"}
    >
      <PasswordForm
        t={t}
        state={state}
        dispatch={dispatch}
        onClick={(status, role) => {
          if (status === "pass") {
            dispatch({ type: "SET_PERMISSION", payload: role });
            // if cookie is not stored then set cookie
            if (!state.lang.cookie) {
              dispatch({
                type: "SET_COOKIE",
              });
            }

            if (role === SuperAdmin) {
              navigate("/overview");
              // window.location.reload();
            } else if (role === CallCenterAgent) {
              navigate("/doctors");
              // window.location.reload();
            }
          }
        }}
      />
    </AuthWrap>
  );
};
